<template>
  <div id="policy-document" class="callout" data-test-policy-document>
    <h3 v-html="modelValue.Headline" />
    <p v-html="modelValue.Description" />

    <a :href="modelValue.DocumentLink.LinkUrl" target="_blank" class="button small">{{
      modelValue.DocumentLink.LinkText
    }}</a>
  </div>
</template>

<script>
export default {
  name: 'PolicyDocument',
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
